// extracted by mini-css-extract-plugin
export default {"dialog__content":"AddProjectUsersPopup_dialog__content__BMIZY"};